/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { makeTitle } from './mixins';
const H1 = styled.h1 `
  ${props => makeTitle(props)}
`;
const H2 = styled.h2 `
  ${props => makeTitle(props)}
`;
const H3 = styled.h3 `
  ${props => makeTitle(props)}
`;
const H4 = styled.h4 `
  ${props => makeTitle(props)}
`;
const H5 = styled.h5 `
  ${props => makeTitle(props)}
`;
export const Title = props => {
    const { level, children } = props;
    const as = `h${level}`;
    const getHeading = () => {
        switch (level) {
            case 1:
                return (React.createElement(H1, Object.assign({}, props, { as: as }), children));
            case 2:
                return (React.createElement(H2, Object.assign({}, props, { as: as }), children));
            case 3:
                return (React.createElement(H3, Object.assign({}, props, { as: as }), children));
            case 4:
                return (React.createElement(H4, Object.assign({}, props, { as: as }), children));
            case 5:
                return (React.createElement(H5, Object.assign({}, props, { as: as }), children));
            default:
                return (React.createElement(H1, Object.assign({}, props, { as: as }), children));
        }
    };
    return getHeading();
};
Title.propTypes = {
    children: PropTypes.string.isRequired,
    level: PropTypes.number.isRequired,
    // variant: PropTypes.string.isRequired,
};
